module.exports = __webpack_public_path__ + "media/svg-new/star-378d94b6.svg";